/*eslint eqeqeq: "off"*/
/*eslint no-useless-escape: "off"*/
/*eslint array-callback-return: "off"*/
/*eslint-disable-next-line: "off"*/
/* eslint-disable */

import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import firebase from '../../config/database'
import Wizzard from "./../../ui/template/Wizzard";
import Tile from "./../../ui/template/Tile"
import Card from './../../ui/template/Card'
import Config from "./../../config/app"
import { Link } from 'react-router'
import T from './../../translations/translate'
import initialAppSettings from '../../config/builder/appsettings.json'

var md5 = require('md5');

const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apps: {},
            name: "",
            id: "",
            type: "blank",
            layout: "side",
            color: "#000000",
            plans: {},
            vendorID: ""
        }
        this.printApps = this.printApps.bind(this);
        this.cloneApp = this.cloneApp.bind(this);
        this.createStep2Content = this.createStep2Content.bind(this);
        this.checkAppCreate = this.checkAppCreate.bind(this);
    }


    componentDidMount() {
        console.log("In create");
        console.log(this.props.params.etype);
        this.setState({
            eventdatapath: this.props.params.etype == "singleevent" ? "applist" : "containers/" + this.props.params.etype
        }, () => {
            console.log(this.state.eventdatapath);
        });
    }


    endStep() {
        //Check if it already exists
        var slug = this.state.name.replace(/ /g, '').toLowerCase();
        var pathToApps = Config.notSaaSAppsPath;
        var apps = firebase.app.database().ref("myapps" + "/" + slug);

        apps.once('value', (snapshot) => {
            if (snapshot.exists()) {
                window.getDemo().showNotification('bottom', 'right', 'danger', "The name <b>" + this.state.name + "</b> is aready added. Pls change name.", "");
            } else {

                var maindata = {
                    "ai": "https://firebasestorage.googleapis.com/v0/b/reactappbuilder-6f0ff.appspot.com/o/xcape%2Fxcape_bg-min.png?alt=media&token=95be9e7b-b00a-4d1d-a943-8af28c3c4810",
                    "edata": 1566124996000,
                    "fb": false,
                    "go": false,
                    "layout": "tab",
                    "login": false,
                    "name": this.state.name,
                    "navi": "https://firebasestorage.googleapis.com/v0/b/reactappbuilder-6f0ff.appspot.com/o/xcape%2Fxcape_bg-min.png?alt=media&token=95be9e7b-b00a-4d1d-a943-8af28c3c4810",
                    "obi": 0.5,
                    "place": "New Delhi",
                    "sdate": 1565865772000,
                    "si": "https://firebasestorage.googleapis.com/v0/b/reactappbuilder-6f0ff.appspot.com/o/xcape%2Fbg_xcape-min.png?alt=media&token=7f8351da-d287-4803-bccb-155cabe27496",
                    "tzo": 5.5,
                    "design": {
                        "navBar": {
                            "backgroundColor": "#23395c",
                            "headingbackcolor": "rgba(255, 255, 255, 0.8)",
                            "itembackcolor": "rgba(170, 179, 188, 0.8)",
                            "tintColor": "#ffffff",
                            "topheadingcolor": "#23395c",
                            "topheadingtextcolor": "#ffffff"
                        },
                        "sideMenu": {
                            "activeBackgroundColor": "#7b8e94",
                            "inactiveBackgroundColor": "#5aa08c",
                            "inactiveTintColor": "#ffffff"
                        }
                    }
                }
                var contentdata = {
                    init: this.state.eventdatapath
                }
                // var appToBeSaved = AppsData[this.state.type];
                // console.log(appToBeSaved);

                // appToBeSaved.name = this.state.name;
                // appToBeSaved.slug = slug;
                // appToBeSaved.id = this.state.id;
                // appToBeSaved.design.general.layout = this.state.layout;
                // console.log(appToBeSaved);
                firebase.app.database().ref(this.state.eventdatapath + "/" + slug).set(maindata);
                firebase.app.database().ref("myapps/" + slug).set(contentdata);
                // firebase.app.database().ref("/applist/" + slug).set({
                //     "fb": false,
                //     "go": false,
                //     "login": false,
                //     "name":this.state.name,
                //     "ai":appToBeSaved.appImage
                // }
                // );


                browserHistory.goBack();





                // var app = firebase.app.database().ref('/apps/' + from);
                // var _this = this;
                // app.once('value', function (snapshot) {
                //     var appToBeSaved = snapshot.val();

                //     var slug = to.replace(/ /g, '').toLowerCase();

                //     //Convert to json 
                //     var jsRepr = JSON.stringify(appToBeSaved);
                //     //console.log(jsRepr);
                //     var find = 'data_point\":\"';
                //     var re = new RegExp(find, 'g');
                //     jsRepr = jsRepr.replace(re, 'data_point\":\"' + slug + '_');
                //     appToBeSaved = JSON.parse(jsRepr);
                //     // console.log(jsRepr);

                //     appToBeSaved.slug = slug;
                //     appToBeSaved.id = id;
                //     appToBeSaved.rabid = rabid;
                //     appToBeSaved.design.general.layout = layout;

                //     //Now add settings, since v 11. 
                //     appToBeSaved.settings = initialAppSettings;

                //     var pathToApps = Config.notSaaSAppsPath;




                //     firebase.app.database().ref(pathToApps + "/" + slug).set(appToBeSaved);
                //     // firebase.app.database().ref("/elist").set(slug);
                //     firebase.app.database().ref("/rab_pointers/data/" + rabid).set(pathToApps + "/" + slug);

                //     browserHistory.goBack();
                // });
            }
        });
    }



    printApps() {
        var _this = this;
        return Object.keys(this.state.apps).map(function (key) {
            return (_this.renderAppTemplate(_this.state.apps[key], key));
        })
    }




    cloneApp(from, to, id, layout, rabid) {

    }


    renderAppTemplate(appData, key) {
        return (
            <Tile
                image={appData.appImage}
                onClick={() => {
                    //Move to next tab and set selected
                    this.setState({
                        type: key,
                        stepsActivity: ["", "active", ""]
                    })
                }}
                isIcon={false}
                subTitle={""}
                title={appData.name}
                buttonTitle={T.td("Use this template")}
            />
        )
    }


    checkAppCreate() {
        if (this.state.name < 3) {
            alert(T.ts("App name missing"))
        } else {
            this.endStep();
        }
    }

    createStep3Content() {
        return (<div className="row">
            <br />
            <div className="col-sm-2">

            </div>
            <div className="col-sm-8">
                <div className="input-group">
                    <span className="input-group-addon">
                        <i className="material-icons">border_color</i>
                    </span>
                    <div className={Config.designSettings.editElementDivClass}>
                        <label className="control-label">{T.td("App name")}
                            <small> ( {T.td("required")} )</small>
                        </label>
                        <input name="name" onChange={(event) => { this.setState({ name: event.target.value }) }} type="text" className="form-control" />
                    </div>
                </div>
                {/* <div className="input-group">
                    <span className="input-group-addon">
                        <i className="material-icons">linear_scale</i>
                    </span>
                    <div className={Config.designSettings.editElementDivClass}>
                        <label className="control-label">{T.td("Package id")}
                            <small> ( {T.td("required")} ex. com.mycompany.app )</small>
                        </label>
                        <input name="packageid" type="text" onChange={(event) => { this.setState({ id: event.target.value }) }} className="form-control" />
                    </div>
                </div> */}
                <button onClick={this.checkAppCreate} className={Config.designSettings.submitButtonClass}>{T.td("Create app")}</button>

            </div>

        </div>)
    }

    createStep1Content() {
        return (<div className="row">{this.printApps()}</div>)
    }

    createStep2Content() {
        return (<div className="row">

            {/* <Tile
                icon={"tab"}
                onClick={() => {
                    this.setState({
                        layout: "tab",
                        stepsActivity: ["", "", "active"]
                    })
                }}
                isIcon={true}
                subTitle={""}
                title={T.td("Tabs")}
                buttonTitle={T.td("Use this layout")}
            /> */}
            <Tile
                icon={"subject"}
                onClick={() => {
                    this.setState({
                        layout: "side",
                        stepsActivity: ["", "", "active"]
                    })
                }}
                isIcon={true}
                subTitle={""}
                title={T.td("Side")}
                buttonTitle={T.td("Use this layout")}
            />
        </div>)
    }

    render() {
        return (
            <div className="main-panel" style={{ width: '100%' }}>
                <div className="container-fluid">
                    <div className="col-sm-2"></div>

                    <input type="hidden" id="appType" ref={(input) => this.appType = input} />
                    <input type="hidden" id="appLayout" ref={(input) => this.appLayout = input} />

                    <Wizzard
                        title={T.ts("Let's make an app")}
                        stateRelate={this.state.apps}
                        wizzardsectionchange={() => {
                            console.log("Wizzard changed")
                        }}

                        stepsActivity={this.state.stepsActivity}
                        steps={[
                            {
                                name: "template",
                                icon: "flip_to_front",
                                title: T.td("Template"),
                                label1: T.ts("Select the app type"),
                                label2: T.ts("What kind of app you will make?"),
                                content: this.createStep1Content()
                            }, {
                                name: "layout",
                                icon: "drag_indicator",
                                title: T.td("Layout"),
                                label1: T.ts("Select the app layout"),
                                label2: T.ts("What kind of app you will make?"),
                                content: this.createStep2Content()
                            },
                            {
                                name: "overview",
                                icon: "check_circle_outline",
                                title: T.td("Overview"),
                                label1: T.ts("Confirm selected and entered data"),
                                label2: T.ts("All informations are required"),
                                content: this.createStep3Content()
                            }]}
                    />

                    <br />
                    <div className="centar text-center">
                        <a className="button" href="/">{T.td("Cancel creating app")}</a>
                    </div>
                </div>
            </div>
        )
    }
}
export default Create;


// WEBPACK FOOTER //
// ./src/containers/Builder/Create.js